import { ICoreConfigInternal } from './core.config.model';

export const CORE_CONFIG: ICoreConfigInternal = {
    apiEndpoint: handleLastUrlSlash(NDD_ENV.apiUrl, 'ApiUrl'),
    apiStandardReportsEndpoint: handleLastUrlSlash(NDD_ENV.reportsUrl, 'ReportsUrl'),
    apiReportsEndpoint: handleLastUrlSlash(NDD_ENV.newReportsUrl, 'NewReportsUrl'),
    apiSignalrEndpoint: handleLastUrlSlash(NDD_ENV.apiHubsUrl, 'ApiHubsUrl'),
    notFound: '/page-not-found',
    authPath: '/login',
    forbidden: '/page-forbidden',
    unauthorized: '/page-unauthorized',
    serverError: '/page-internal-server-error',

    googleAnalyticsTrackingId: NDD_ENV.googleAnalyticsTrackingId,
    customCssFileByDns: NDD_ENV.customCssFileByDns,
};

// tslint:disable-next-line:only-arrow-functions
function handleLastUrlSlash(url: string, urlName: string): string {
    if (!url) {
        throw new Error(`${ urlName } is null or empty.`);
    }

    return url.endsWith('/') ? url : `${ url }/`;
}
